import { render, staticRenderFns } from "./LogActivityTable.vue?vue&type=template&id=da41a822"
import script from "./LogActivityTable.vue?vue&type=script&lang=js"
export * from "./LogActivityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports